export function useMaintenance() {
    const state = useState<MaintenanceState>('maintenance-state', () => ({
        mode: 'disabled',
        changedAt: null,
        changedBy: null,
    }))
    const mode = computed(() => state.value.mode)

    async function refresh() {
        try {
            const response = await $fetch<ApiResponse<MaintenanceState>>('/api/maintenance')
            if (response.success) state.value = response.data
        } catch (error) {
            console.error('Could not load maintenance mode', error)
        }
    }

    // `confirm` must repeat `mode`; the server rejects the change otherwise.
    async function setMode(next: MaintenanceMode, confirm: string) {
        const response = await $fetch<ApiResponse<MaintenanceState>>('/api/maintenance', {
            method: 'PUT',
            body: { mode: next, confirm },
        })
        if (!response.success) throw new Error(response.message)
        state.value = response.data
        return response.data
    }

    return { state, mode, refresh, setMode }
}
